import ToastMe from '@/components/ui/ToastMe';

/**
 * Unified API error handler
 * - Shows the first validator error message (express-validator)
 * - Falls back to server 'message'
 * - Falls back to 'Network error' if no response
 */
export default function ApiErrorHandler(err, toastShow = true) {
  const statusCode = err?.response?.status ?? 0;
  const payload    = err?.response?.data;
  const errorsArr  = Array.isArray(payload?.errors) ? payload.errors : [];
  const message    = payload?.message || '';
  const code       = payload?.code || '';

  // Build return object
  const data = {
    errorData: errorsArr.length ? errorsArr : '',
    statusCode,
    code,
    message: message || '',
    data: payload?.data ?? null,
  };

  if (toastShow) {
    if (errorsArr.length) {
      // express-validator shape: { msg, param, location, ... }
      const firstMsg =
        errorsArr[0]?.msg ||
        (typeof errorsArr[0] === 'string' ? errorsArr[0] : 'Validation failed');
      ToastMe(firstMsg, 'error');
    } else if (message && statusCode !== 401 && code !== 'company_selection_required') {
      ToastMe(message, 'error');
    } else if (!err?.response) {
      // e.g., ECONNREFUSED, CORS, DNS, offline
      ToastMe('Network error: API unreachable', 'error');
    }
  }

  // Log compactly
  if (statusCode >= 500) {
    console.error('[API 5xx]', err, data);
  } else {
    console.log('[API]', { statusCode, message, errors: errorsArr, url: err?.config?.url });
  }

  return data;
}
